import upcomingShiftsToClockInHTML from './upcomingShiftsToClockInComponent.html';

class UpcomingShiftsToClockInCtrl {
  constructor(Authentication) {
    'ngInject';

    Object.assign(this, { Authentication });
  }

  $onChanges() {
    if (this.upcomingShifts.length) {
      this.when = new Date(
        this.upcomingShifts[0].dtstartLocal.getTime() -
          this.Authentication.user.orgSettings.clockInEarlyMinutes * 60 * 1000
      );
    }
  }
}

export default {
  bindings: {
    upcomingShifts: '<src',
  },
  controller: UpcomingShiftsToClockInCtrl,
  controllerAs: 'ctrl',
  templateUrl: upcomingShiftsToClockInHTML,
};
